import React from "react";

import {
  FaCoffee,
  // FaTwitter,
  FaRegHeart,
  FaFacebookF,
  FaInstagram,
  FaRegCopyright,
} from "react-icons/fa";

import { AiOutlineYoutube } from "react-icons/ai";

import "../css/footer.css";
const Footer = () => {
  return (
    <footer>
      <span className="social">
        <h1>Find Me</h1>
        <a href="https://www.facebook.com/hossam.rabei">
          <li className="socialFa">
            <FaFacebookF title="Facebook" />
          </li>
        </a>

        <a href="https://www.instagram.com/hossamrabei/">
          <li className="socialFa">
            <FaInstagram title="Instagram" />
          </li>
        </a>
        <a href="https://www.youtube.com/channel/UCYyhzyvUNNCIg9VqZ0ndHyg">
          <li className="socialFa youtube">
            <AiOutlineYoutube title="Youtube" />
          </li>
        </a>
        {/* <a href="https://www.twitter.com">
          <li className="socialFa">
            <FaTwitter title="Twitter" />
          </li>
        </a> */}
      </span>

      <hr />

      <div className="credits">
        <h3>
          Made with <FaRegHeart title="Love" className="fa" /> and{" "}
          <FaCoffee title="Coffee" className="fa" /> <span className="break" />
          by <span className="break" />
          <a
            href="https://youssefrabei.netlify.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <u>
              <i>Youssef Rabei</i>
            </u>
          </a>
        </h3>

        <h5>
          <FaRegCopyright title="Copy right" className="fa" />{" "}
          <i>{new Date().getFullYear()}</i> All Rights Reserved
        </h5>
      </div>
    </footer>
  );
};

export default Footer;
